/**
 * Generates a formatted label for a practitioner option in the dropdown
 * @param {Object} practitioner - The practitioner object
 * @param {string} practitioner.lastName - Practitioner's last name
 * @param {string} practitioner.firstName - Practitioner's first name
 * @param {string} practitioner.npiTypeI - Practitioner's NPI Type I
 * @param {Array} [practitioner.practitionerLink] - Array of practitioner links with termination info
 * @returns {string} Formatted practitioner label
 */
export const generatePractitionerLabel = practitioner => {
	if (!practitioner) {
		return '';
	}

	const { lastName, firstName, npiTypeI, practitionerLink } = practitioner;

	// Find the most recent practitioner link if it exists
	const mostRecentPractitionerLink =
		practitionerLink?.length > 0
			? practitionerLink.reduce((prev, current) =>
					current.seq > prev.seq ? current : prev
				)
			: null;

	// Build the base label with name and NPI
	const baseLabel = `${lastName}, ${firstName} - ${npiTypeI}`;

	// Add termination date if applicable
	const terminationSuffix = mostRecentPractitionerLink?.termDate
		? ` (Termed ${new Date(mostRecentPractitionerLink.termDate).toDateString()})`
		: '';

	return `${baseLabel}${terminationSuffix}`;
};
